import { updatedConstants, userConstatnt } from "../_constants/user.constant";


const initialValues = {
    tba: null
}

export function userstatus(state = initialValues, actions: any) {
    switch (actions.type) {
        case userConstatnt.USERDATA:
            return { tba: actions.tba };
        default:
            return state;
    }
}
export function menuid(state = 0, actions: any) {
    switch (actions.type) {
        case userConstatnt.MENUID:
            return { menuId: actions.menuId };
        default:
            return state;
    }
}
export function menuitems(state = {}, actions: any) {
    switch (actions.type) {
        case userConstatnt.MENUITEMS:
            return { menu: actions.menu };
        default:
            return state;
    }
}

export function locationsdata(state = { data: null }, actions: any) {
    switch (actions.type) {
        case userConstatnt.LOCATIONS:
            return { data: actions.data };
        default:
            return state;
    }
}

//#region set parameter true and false 
export function update(state = { isUpdate: false }, actions: any) {
    switch (actions.type) {
        case updatedConstants.UPDATED:
            return {
                isUpdate: true,
            };
        case updatedConstants.UPDATEDCLEAR:
            return {
                isUpdate: false
            }
        default:
            return state;
    }
}
//#endregion